import { render, staticRenderFns } from "./SetSource.vue?vue&type=template&id=18fbb876&scoped=true&"
import script from "./SetSource.vue?vue&type=script&lang=js&"
export * from "./SetSource.vue?vue&type=script&lang=js&"
import style0 from "./SetSource.vue?vue&type=style&index=0&id=18fbb876&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18fbb876",
  null
  
)

export default component.exports